import { useHistory } from "react-router";

import { useGetAllRelationships, useGetOwnerDetails } from "~/v2/api/hooks";
import { FeatureFlags, useFeatureEnabled } from "~/v2/helpers/featureFlags";
import { Path } from "~/v2/path";
import { useAccountContext } from "~/v2/providers/AccountProvider";

export const useFundingHomeController = () => {
  const history = useHistory();
  const { currentAccount } = useAccountContext({ liveOnly: true });
  const { details } = useGetOwnerDetails();

  const relationships = useGetAllRelationships({
    account: currentAccount,
    countryOfTaxResidence: details?.country_of_tax_residence || "",
  });
  const isRelationshipsLoading = Object.values(relationships).some(
    (value) => value.isLoading,
  );

  const onWithdrawClicked = () => {
    history.push(Path.ROUTE_FUNDING_WITHDRAW);
  };

  const onDepositClicked = () => {
    history.push(Path.ROUTE_FUNDING_DEPOSIT);
  };

  const onPortfolioTransferClicked = () => {
    history.push(Path.ROUTE_PORTFOLIO_TRANSFER);
  };

  // Non-IRA accounts can always withdraw. IRA accounts (traditional + Roth) use
  // the distribution flow, which is gated behind the `ira-account-withdrawals`
  // Unleash flag until rollout is complete.
  const isIRAAccount = currentAccount?.account_type === "ira";
  const isIRAWithdrawalsEnabled = useFeatureEnabled(
    FeatureFlags.IRA_WITHDRAWALS,
  );
  const showWithdraw = !isIRAAccount || isIRAWithdrawalsEnabled;

  const isLoading = !currentAccount || !details || isRelationshipsLoading;

  return {
    accountID: currentAccount?.id ?? "",
    relationships,
    isLoading,
    showWithdraw,
    onWithdrawClicked,
    onDepositClicked,
    onPortfolioTransferClicked,
  };
};
